'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isVideoUrl = exports.happyES = exports.resolvePlatformIcon = exports.getSupportingDataField = exports.getS3Url = undefined;

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getS3Url = exports.getS3Url = function getS3Url(url) {
  var defaultUrl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'https://s3-eu-west-1.amazonaws.com/dyzio-static-files/images/instagram-story2.png';

  if (!url) return defaultUrl;
  var bucket = 'https://s3-eu-west-1.amazonaws.com/discussions-uploads-production/';
  return '' + bucket + url;
};

var getSupportingDataField = exports.getSupportingDataField = function getSupportingDataField(supportingData) {
  var key = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'impressions';
  var defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

  var filtered = _lodash2.default.filter(supportingData, 'createdDate'); // remove the GraphQL null at [0]
  var ordered = _lodash2.default.reverse(_lodash2.default.sortBy(filtered, function (o) {
    return o.createdDate;
  }));
  var lastSupportingData = _lodash2.default.head(ordered);

  if (key === 'filePath') {
    return _lodash2.default.get(lastSupportingData, key, null);
  }

  if (_lodash2.default.has(lastSupportingData, 'data.' + key)) {
    return _lodash2.default.toInteger(_lodash2.default.get(lastSupportingData, 'data.' + key, 0));
  }
  return _lodash2.default.toInteger(_lodash2.default.get(lastSupportingData, key, defaultValue));
};

var resolvePlatformIcon = exports.resolvePlatformIcon = function resolvePlatformIcon(platform) {
  var icons = {
    SNAPCHAT: {
      color: 'yellow',
      name: 'snapchat'
    },
    VK: {
      color: 'blue',
      name: 'vk'
    },
    BLOG: {
      color: 'gray',
      name: 'pencil'
    },
    DEFAULT: {
      color: 'pink',
      name: 'image'
    }
  };
  return _lodash2.default.get(icons, platform);
};

var happyES = exports.happyES = function happyES() {
  var name = 'MD';
  return name;
};

var isVideoUrl = exports.isVideoUrl = function isVideoUrl(url) {
  console.log('isVideoUrl', url);
  var videoFormats = ['.mp4', '.mov', '.avi', 'wmv'];
  var result = false;
  _lodash2.default.forEach(videoFormats, function (format) {
    if (_lodash2.default.includes(_lodash2.default.toLower(url), format)) {
      result = true;
    }
  });
  console.log('isVideoUrl', result);
  return result;
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/dyzio-shared-components/lib/utils/assets.js
 ** module id = 243
 ** module chunks = 0
 **/